import { render, staticRenderFns } from "./CurrentRevision.vue?vue&type=template&id=2bfe2e02&scoped=true"
import script from "./CurrentRevision.vue?vue&type=script&lang=js"
export * from "./CurrentRevision.vue?vue&type=script&lang=js"
import style0 from "./CurrentRevision.vue?vue&type=style&index=0&id=2bfe2e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe2e02",
  null
  
)

export default component.exports